/**
 * [INPUT]: 依赖 Vite 的开发模式标识与可选 VITE_API_BASE_URL 覆盖配置
 * [OUTPUT]: 对外提供 API 基地址解析器、统一归一化的 admin API 基地址与 origin
 * [POS]: admin-web 基础设施配置边界；生产构建固定连接真实 server，只有开发模式允许本地联调覆盖
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
const PRODUCTION_API_BASE_URL = 'https://elseyou.yoghourt.space/api/v1';

export function resolveApiBaseUrl(configuredApiBaseUrl: string | undefined, isDevelopment: boolean): string {
  const localOverride = isDevelopment ? configuredApiBaseUrl?.trim() : undefined;
  return (localOverride || PRODUCTION_API_BASE_URL).replace(/\/$/, '');
}

export const apiBaseUrl = resolveApiBaseUrl(import.meta.env.VITE_API_BASE_URL, import.meta.env.DEV);
export const apiOrigin = apiBaseUrl.replace(/\/api\/v1\/?$/, '');
